import React from 'react';
import PropTypes from 'prop-types';
import TableHead from './TableHead'
import TableBody from './TableBody'

import { SliceTableStyle } from './styled'

const Table = ({data, preview}) => {
    return (
      <SliceTableStyle>
        <TableHead 
          colLeft={data.primary.left_column_heading}
          colRight={data.primary.right_column_heading}
        />
        <TableBody data={data} preview={preview} />
      </SliceTableStyle>
    );
};

Table.propTypes = {
  data: PropTypes.object,
  preview: PropTypes.bool
}

export default Table;